import React from 'react';
import { Card, CardHeader, CardContent, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

export const Alert = () => {
  const location = useLocation();

  return (
    <Card>
      <CardHeader title={location.state && location.state.alert ? location.state.alert.title : ''} />
      <CardContent>
        <Typography>
          {location.state && location.state.alert ? location.state.alert.content : ''}
        </Typography>
      </CardContent>
    </Card>
  );
};
